import { format } from 'date-fns';

import { DatePickerDisplayFormat } from 'components/generic-question/DateTimePickers';

const getTimeString = (date: Date): string => {
  return format(date, DatePickerDisplayFormat.TIME_FORMAT_12H);
};

export { getTimeString };
